module.exports = "<input type=\"text\" daterangepicker class=\"daterange\" placeholder=\"YYYY-MM-DD\"\n       [options]=\"calendarOption\"\n       (keydown)=\"onDateChange($event)\"\n       (keyup.enter)=\"onDateChange($event)\"\n       (blur)=\"onDateChange($event)\"\n       [(ngModel)]=\"date\"\n       (applyDaterangepicker)=\"calendarApplied($event)\"\n       (selected)=\"selectedDate($event)\" />\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calendar-picker/calendar-picker.component.html
// module id = ./src/app/components/calendar-picker/calendar-picker.component.html
// module chunks = main